export default __webpack_public_path__ + "static/media/141.bd528378.jpg";